jQuery(function($) {

  console.log("javascript init");

  // Menu toggle

  $("#toggle-mobile-menu").on("click", function() {
    // Reset Search
    $(".search-menu").removeClass("open");
    $(".toggle-search").find(".fa-search").removeClass("open").parent().parent().removeClass("active");
    // Activate menu
    $(".mobile-menu").toggleClass("open");
    $(this).find("#nav-icon2").toggleClass("open").parent().parent().toggleClass("active");
    $("body").toggleClass("no-scroll");
    //$("#at-share-dock").toggle();
  });

  // Search menu toggle

  $(".toggle-search").click( function() {
    // Reset Nav menu
    $("#toggle-mobile-menu").find("#nav-icon2").removeClass("open").parent().parent().removeClass("active");
    $(".mobile-menu").removeClass("open");
    // Activate Search
    $(".search-menu").toggleClass("open");
    $(this).find(".fa-search").toggleClass("open").parent().parent().toggleClass("active");
  });

  // conference menu toggle

  $("#toggle-conference-menu").on("click", function () {
    // Activate menu
    $(".conference-mobile-navigation").toggleClass("open");
    $(this).find("#nav-icon2").toggleClass("open").parent().parent().toggleClass("active");
  });

  // Fix menu on scroll

  $(document).scroll(function(){
    if($(this).scrollTop() >= 5) {
      $("#masthead").addClass("affix");
    } else {
      $("#masthead").removeClass("affix");
    }
  });

  // Search box

  $("#submit-search").on("click", function() {
    var search_query = $("#search-input").val();

    window.location = window.location.origin + "/search.aspx?searchtext=" + search_query;
  });

  $("#search-input").on('keyup', function (e) {
    if (e.keyCode == 13) {
      window.location = window.location.origin + "/search.aspx?searchtext=" + $(this).val();
    }
  });

  // Hide blue area

  if($(".blue-content-area .col-lg-8").children().length == 0) {
    $(".blue-content-area").hide();
  }

  // Shrink content if ad's exist

  if($(".ad-skyscraper").length) {
    $("body").addClass("skyscraper-ad");
  }

  if($(".ad-halfpage").length) {
    $("body").addClass("halfpage-ad");
  }

  // Change french text in toggle buttons

  $(".lang-toggle").text(function() {
    return $(this).text().replace("French", "Français");
  }); 

  $(".homepage .post:not(.featured) .thumb").hover(function() {
    $(this).parent().parent().find(".btn").toggleClass("hovered");
  });

  // Placeholders on contact form 

  $(".contact-page-form .form-table-group, .newsletter-signup-form .form-group").each(function() {
    var label = $(this).find(".control-label").text().replace(":", "");

    if(label !== undefined) {
      $(this).find(".form-control").attr("placeholder", label);
    }
  });

  // Remove colspan 

  $(".cas-forum .ForumName").removeAttr("colspan");

});
